import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FlorderMaterialLinesComponent } from '../../florder/florder-material-lines/florder-material-lines.component';
import { OrderMaterial } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';

@Component({
  selector: 'app-relocation-material-lines',
  templateUrl: './relocation-material-lines.component.html',
  styleUrls: ['../../florder/florder-material-lines/florder-material-lines.component.scss'],
})
export class RelocationMaterialLinesComponent extends FlorderMaterialLinesComponent<OrderMaterial> {
  @Input() titlePart: string;

  constructor(breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super(breakpointObserver, cd);
  }
}
